export default __webpack_public_path__ + "static/media/wi-night-clear.2923306b.svg";